import { useMutation, useQueryClient } from '@tanstack/react-query';

import { unwrap } from '@/lib/result';

import { authRepository } from '../api/auth.repository';

export function useSendOtp() {
  return useMutation({
    mutationFn: (phone: string) => unwrap(authRepository.sendOtp(phone)),
  });
}

export function useVerifyOtp() {
  return useMutation({
    mutationFn: (vars: { phone: string; token: string }) =>
      unwrap(authRepository.verifyOtp(vars.phone, vars.token)),
  });
}

/** Dev-only email+password sign-in (see env.devEmailAuth). */
export function useEmailAuth() {
  return useMutation({
    mutationFn: (vars: { email: string; password: string }) =>
      unwrap(authRepository.signInWithEmail(vars.email, vars.password)),
  });
}

export function useSignOut() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => unwrap(authRepository.signOut()),
    onSuccess: () => queryClient.clear(),
  });
}
